import { useDictionaryContext } from "@/components/dictionaries/DictionaryContext";
import SaveButton from "@/components/SaveButton";
import { Button } from "@/components/ui/button";
import { Trash2, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";

export default function AgreementCompanyEditorFooter() {
  const { t } = useTranslation();
  const { deleteMutation } = useDictionaryContext();
  const { can_delete } = useModulePermissions();

  return (
    <div className="flex justify-end gap-2">
      <Button
        variant="destructive"
        onClick={deleteMutation?.mutateAsync}
        disabled={deleteMutation?.isPending || !can_delete}
      >
        {deleteMutation?.isPending ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Trash2 className="w-4 h-4" />
        )}
        {deleteMutation?.isPending
          ? t("common.deleting")
          : t("agreementCompanies.delete")}
      </Button>
      <SaveButton />
    </div>
  );
}
